export default "__VITE_ASSET__BaOqoLfP__"